import { AppointmentByIdQuery, AppointmentReviewMutation, GetToken } from '@water-web/api';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const AppointmentServiceConstructor = (config: { baseUrl: string; getToken: GetToken }) => ({
  getById: new AppointmentByIdQuery(config.baseUrl),
  review: new AppointmentReviewMutation(config),
});
